module.exports = __webpack_public_path__ + "img/mult-color.8e51c092.jpeg";